import { render, staticRenderFns } from "./InsureFile.vue?vue&type=template&id=9f025bea&scoped=true&"
import script from "./InsureFile.vue?vue&type=script&lang=js&"
export * from "./InsureFile.vue?vue&type=script&lang=js&"
import style0 from "./InsureFile.vue?vue&type=style&index=0&id=9f025bea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f025bea",
  null
  
)

export default component.exports